import Component from '@glimmer/component';
import { service } from '@ember/service';
import type NetworkStatus from '../services/network-status';
import type OfflineQueue from '../services/offline-queue';
import Icon from './icon';
import WifiOffIcon from '~icons/lucide/wifi-off';

export default class OfflineBanner extends Component {
  @service declare networkStatus: NetworkStatus;
  @service declare offlineQueue: OfflineQueue;

  get queueLabel(): string {
    const count = this.offlineQueue.pendingCount;
    if (count === 0) return '';
    return ` — ${count} item${count > 1 ? 's' : ''} queued`;
  }

  <template>
    {{#unless this.networkStatus.isOnline}}
      <div
        class="alert alert-warning rounded-none py-2 text-sm shadow-sm"
        role="status"
        data-test-offline-banner
      >
        <Icon @icon={{WifiOffIcon}} class="h-4 w-4 shrink-0" />
        <span>You're offline{{this.queueLabel}}</span>
      </div>
    {{/unless}}
  </template>
}
